import _ from "lodash";
import {
  ADD_NEW_STREAM,
  ADD_PROJECT,
  CLEAR_STREAMS,
  CONTEXT_SEARCH,
  DELETE_STREAM,
  GET_PROJECTS,
  IS_EMPTY_STREAM,
  IS_LAST_STREAM,
  REMOVE_PROJECT,
  SET_IN_EDIT_MODE,
  STORE_EMOJI,
  STORE_LEVEL,
  STORE_PROJECT_STREAMS,
  STORE_TOTAL_DRAFT_STREAMS,
  STREAMS_MARK_AS_READ,
  UPDATE_PROJECT,
  UPDATE_PROJECT_DESC,
  UPDATE_STREAM_EMOJI,
} from "../actions/action-types";
import { number } from "../config/index";
import { isDateValid } from "../shared/validators/validator";

const initialState = {
  description: "",
  data: [],
  projectFilters: "",
  queuePrivacy: [],
  streams: [],
  emojiIcons: [],
  emptyStreams: false,
  isLastStream: false,
  contextSearch: "",
  streamLevel: [],
  totalDraftStreams: 0,
  inEditMode: false,
};

/**
 * Updates objects within object
 * @param {object} Stream State
 * @param {Object} object to be updated
 * @returns
 */

export const updatedProjectStreamEmoji = (data, payload) => {
  const { count, isMine, reaction, streamId } = payload;
  const streamToUpdate = data.find((obj) => obj.Id === streamId);
  if (streamToUpdate) {
    const emojiToUpdate = streamToUpdate.emojis.find((innerObj) => innerObj.emoji === reaction);
    if (emojiToUpdate) {
      emojiToUpdate.count = emojiToUpdate.count + count;
      emojiToUpdate.isMine = isMine;
    } else {
      const newEmojiObject = { emoji: reaction, count: count, isMine: isMine };
      streamToUpdate.emojis.push(newEmojiObject);
    }
  }
  return data;
};

/**
 * Updates objects within object
 * @param {object} Stream State
 * @param {Object} object to be updated or added
 * @returns
 */
export const updatedStreamState = (data, payloadStream) => {
  let newStreamState = [];
  let index = data?.findIndex((i) => i.Id == payloadStream.Id);
  if (index != number.MINUS_ONE) {
    payloadStream.emojis = data[index]?.emojis;
    data[index] = payloadStream;
    newStreamState = data;
  } else {
    newStreamState = data;
    payloadStream.emojis = [];
    newStreamState.unshift(payloadStream);
  }
  return _.orderBy(newStreamState, [(item) => (isDateValid(item?.DateAndTime) ? new Date(item?.DateAndTime).getTime() : 0)], ["desc"]);
};

export const updateRead = (data, streamId) => {
  return data.map((item) => {
    if (item.Id === streamId) {
      return { ...item, IsRead: 1 };
    }
    return item;
  });
};

/**
 * setting states according to the type of actions
 * @param {*} state
 * @param {*} action
 * @returns {state}
 */

const allProjects = (state = initialState, action) => {
  const { data, queuePrivacy } = action.payload ?? {};
  switch (action.type) {
    case GET_PROJECTS:
      return {
        ...state,
        data: data,
        queuePrivacy: queuePrivacy?.length && queuePrivacy,
      };
    case STORE_PROJECT_STREAMS:
      return {
        ...state,
        streams: [...(state?.streams || []), ...action.payload],
      };
    case STORE_EMOJI:
      return {
        ...state,
        emojiIcons: action.payload,
      };

    case STORE_TOTAL_DRAFT_STREAMS:
      return {
        ...state,
        totalDraftStreams: action.payload,
      };

    case STORE_LEVEL:
      return {
        ...state,
        streamLevel: action.payload,
      };

    case UPDATE_PROJECT_DESC:
      return {
        ...state,
        description: action.payload || "",
      };
    case UPDATE_STREAM_EMOJI:
      let streams = state.streams;
      return {
        ...state,
        streams: updatedProjectStreamEmoji(streams, action.payload),
      };
    case ADD_NEW_STREAM:
      let oldStream = state.streams;
      return {
        ...state,
        streams: [...updatedStreamState(oldStream, action.payload)],
      };
    case DELETE_STREAM:
      let oldStreamData = state.streams;
      return {
        ...state,
        streams: oldStreamData.filter((stream) => stream.Id !== action.payload.streamId),
      };
    case IS_LAST_STREAM:
      return {
        ...state,
        isLastStream: action.payload,
      };
    case IS_EMPTY_STREAM:
      return {
        ...state,
        emptyStreams: action.payload,
      };
    case STREAMS_MARK_AS_READ: {
      let streams = state.streams;
      return {
        ...state,
        streams: updateRead(streams, action.payload),
      };
    }
    case CLEAR_STREAMS:
      return {
        ...state,
        description: "",
        streams: [],
        emojiIcons: [],
        isLastStream: false,
      };
    case ADD_PROJECT:
      return {
        ...state,
        data: [...state.data, action.payload],
      };
      case REMOVE_PROJECT:
      return {
        ...state,
        data: state.data.filter((project) => project.ProjectId !== action.payload.ProjectId),
      };

    case UPDATE_PROJECT:
      return {
        ...state,
        data: state.data.map((project) => {
          if (project.ProjectId === action.payload.ProjectId) {
            const updatedProject = { ...project };
            for (const key in action.payload) {
              if (action.payload.hasOwnProperty(key) && action.payload[key] !== undefined) {
                updatedProject[key] = action.payload[key];
              }
            }
            return updatedProject;
          }
          return project;
        }),
      };
    case CONTEXT_SEARCH:
      return {
        ...state,
        contextSearch: action.payload,
      };
    case SET_IN_EDIT_MODE:
      return {
        ...state,
        inEditMode: action.payload,
      };
    default:
      return state;
  }
};

export default allProjects;
